module.exports = __webpack_public_path__ + "h5/static/img/easyTransfer-logo.aaa62a20.png";